import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'

/**
 * Centered layout used by /login and any future unauthenticated screens.
 * If the user is already authenticated, redirect to /dashboard.
 */
export function AuthLayout(): React.ReactElement {
  const token = useAuthStore((s) => s.token)
  if (token) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4 py-12">
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  )
}
